import { ISearchPromosV2ResponseSchema } from '../repositories/newbuilding-promos/entities/search_promos_v2/SearchPromosV2ResponseSchema';
import { TTotalCount } from '../types/totalCount';

export const mapTotalCountText = (promosResponse: ISearchPromosV2ResponseSchema): TTotalCount => {
  const totalCount = promosResponse.promoSearchResult.totalCountText;

  return totalCount || null;
};
